//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server } from "@/services/constants";
import TimeLineOperations from "../timeline/TimeLineOperations.vue"; // ⭐ เพิ่มใหม่
import InvoiceSectionPanel from "../payment-invoice/InvoiceSectionPanel.vue";

// ✅ ไฟล์ incorporate อยู่ที่ production storage port 3001
const INCORPORATE_DOCKET_FILE_URL = process.env.VUE_APP_PRODUCTION_STORAGE_URL
  ? `${process.env.VUE_APP_PRODUCTION_STORAGE_URL}/incorporatedocket`
  : "http://localhost:3001/incorporatedocket";

import { getIncorporateDocketById } from "@/services/api-dtime/api_incorporate";
import { getIncorporateDocketDocCategoryByDocketId } from "@/services/api-dtime/api_incorporate_docket_doc_category";

export default {
  name: "incorporate-docket-view",
  components: { TimeLineOperations, InvoiceSectionPanel }, // ⭐ เพิ่มใหม่
  data() {
    return {
      loading: true,
      docket: null,
      fileIncorporateUrl: INCORPORATE_DOCKET_FILE_URL,
      docCategories: [],
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: "",
      userId: "",

      // ⭐ เพิ่มใหม่ทั้งหมด — สำหรับส่วน Timeline (read-only)
      loadingTimeline: true,
      module_name: "Corporate",
      statuslist: [],
      reportlist: [],
      // ⭐ TimeLineOperations ต้องการ prop "showaddItem" เป็น Object เสมอ
      // (ใช้แสดง Reported/Invoiced เมื่อ showReportInv=true) — หน้านี้ปิด
      // showReportInv ไว้อยู่แล้ว จึงส่ง object เปล่าไปพอ ไม่กระทบอะไร
      timelineForm: {},
      //quotations
      formQutations: {
        salesOrderId: 0,
        price: 0,
        customerName: "",
        currency: "",
      },
      salesOrderList: [],
      invoiceList: [],
      // invoiceMenu: false,
      // invoiceMenuPay: false,
      invoiceStatusList: ["Draft", "Requested", "Invoiced", "Paid"],
      quotationscheckstatus: '',
      modeOperations: 'Edit'
    };
  },
  computed: {
    docCategoryList() {
      return this.docCategories.map((c) => c.doc_category);
    },
    // ⭐ ใช้ docket.changes (จากตาราง incorporate_docket_change) เป็นหลัก
    // ถ้า backend ยังไม่ส่ง changes มา (เช่น docket เก่า) จะ fallback ไปอ่าน
    // change_tracker text เดิมแทน เพื่อไม่ให้หน้าจอพังกับข้อมูลเก่า
    changeTrackerList() {
      if (
        Array.isArray(this.docket?.changes) &&
        this.docket.changes.length > 0
      ) {
        return this.docket.changes.map((c) =>
          this.changeTypeLabel(c.change_type),
        );
      }
      if (!this.docket?.change_tracker) return [];
      return this.docket.change_tracker
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    },
    attachmentList() {
      if (!this.docket?.file_attachments) return [];
      return this.docket.file_attachments
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async mounted() {
    await this.loadDataInvoice(this.$route.params.id);
    await this.loaddataSalesOrder();
    this.$hideLoader();
    this.userId = localStorage.getItem(server.USER_ID);
    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    let parser = document.createElement("a");
    parser.href = window.location;
    const router_path = "incorporate-docket-list"; // ใช้ permission เดียวกับ list
    try {
      const { default: api } = await import("@/services/api");
      const res_auth = await api.getAuthorize(this.userId, router_path);
      this.authorize_view = res_auth.data[0].smd_view >= 1;
      this.authorize_add = res_auth.data[0].smd_add >= 1;
      this.authorize_edit = res_auth.data[0].smd_edit >= 1;
      this.authorize_del = res_auth.data[0].smd_del >= 1;
    } catch (error) {
      console.error("Error checking authorize:", error);
    }

    const id = this.$route.params.id;
    await this.loadDocket(id); // เดิม ไม่แตะ
    await this.loadDocCategories(id);
    this.loading = false; // เดิม ไม่แตะ

    // ⭐ เพิ่ม — โหลด statuslist สำหรับส่วน Timeline หลังจากโหลด docket
    // เสร็จแล้ว (ไม่ block การแสดงข้อมูลหลักของหน้า ให้ section Timeline
    // โชว์ loading spinner ของตัวเองแยกต่างหาก ผ่าน loadingTimeline)
    await this.loaddataLitigationCourtStatus();
    this.loadingTimeline = false;
  },
  methods: {
    // ⭐ เพิ่มใหม่ — โหลด Document Category จากตารางลูก
    // รองรับทั้ง response แบบ { success, data: [...] } และแบบ array ตรงๆ
    async loadDocCategories(id) {
      try {
        const res = await getIncorporateDocketDocCategoryByDocketId(id);
        const list = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
            ? res.data.data
            : [];
        this.docCategories = list.map((item) => ({
          id: item.id,
          doc_category: item.doc_category,
        }));
      } catch (error) {
        console.error("Error loading doc categories:", error);
        // ไม่ block การโหลดหน้าเพียงเพราะโหลดส่วนนี้ไม่สำเร็จ
      }
    },
    previewInvoice(item) {
      const routeData = this.$router.resolve(
        `/edit-invoice/${item.inv_id_preview}/inv_h/edit`
      );
      window.open(routeData.href, '_blank');
    },
    //quotations 
    async loaddataSalesOrder() {
      try {
        const res = await api.getQuotatinsForDocketCore(Number(localStorage.getItem(server.COMPANYID)));
        this.salesOrderList = res.data || [];

      } catch (error) {
        console.error("loaddataSalesOrder error:", error);
      }
    },
    onSelectSO(value) {
      if (!value) {
        this.formQutations.price = "";
        return
      }
      // หา object ของ SO ที่เลือก
      const so = this.salesOrderList.find(item => item.quotation_id === value);
      if (so) {
        this.quotationscheckstatus = so.status;
        this.formQutations.price = Number(so.subtotal);
      }
    },
    async loadDataInvoice(id) {
      try {
        var dataserach = {
          module_name: 'Incorporation',
          module_id: id,
          company_id: Number(localStorage.getItem(server.COMPANYID)),
        }
        const res = await api.getQuotatinsinvoiceListCore({
          params: dataserach
        })
        this.invoiceList = res.data.data || [];
      } catch (error) {
        console.error("loadDataInvoice error:", error);
      }
    },
    //end quotattions
    async loadDocket(id) {
      try {
        const res = await getIncorporateDocketById(id);
        this.docket = res.data;

        // เติมข้อมูล quotation ที่ผูกกับ docket นี้ลงส่วนการเงิน (แสดงอย่างเดียว)
        this.formQutations.salesOrderId = this.docket.quotation_id || 0;
        const so = this.salesOrderList.find(
          (item) => Number(item.quotation_id) === Number(this.formQutations.salesOrderId)
        );
        if (so) {
          this.formQutations.price = Number(so.subtotal);
          this.formQutations.customerName = so.customer_name || "";
          this.formQutations.currency = so.currency || "";
          this.quotationscheckstatus = so.status;
        }
      } catch (error) {
        console.error("Error loading docket:", error);
      }
    },

    // ⭐ เพิ่มใหม่ — โหลด config สถานะ (client_timeline_status_config)
    // จำเป็นสำหรับ TimeLineOperations แม้จะปิดการ์ด input ไว้ก็ตาม เพราะ
    // ตัว component เองต้องใช้ hydration บางส่วน (ไม่ได้ error ถ้าไม่ส่งมา
    // แต่ปลอดภัยกว่าถ้าโหลดให้ครบตาม pattern เดียวกับหน้า Add/Edit/List)
    async loaddataLitigationCourtStatus() {
      try {
        const { default: api } = await import("@/services/api");
        const result = await api.getClientTimelineStatusCongFigByModule(
          "Corporate",
        );
        this.statuslist = (result.data || []).map((item) => ({
          ...item,
          module_id: item.module_id,
        }));
      } catch (error) {
        console.error("Error loading status config:", error);
      }
    },

    // ⭐ แปลง change_type (key) ให้เป็น label อ่านง่ายในหน้า View
    changeTypeLabel(key) {
      const map = {
        shareholders: "👥 Shareholders | ผู้ถือหุ้น",
        directors: "👔 Directors | กรรมการบริษัท",
        "reg-capital": "💰 Registered Capital (THB)",
        "paidup-capital": "💵 Paid-up Capital (THB)",
        "company-name": "🏢 Company Name | ชื่อบริษัท",
        "reg-address": "📍 Registered Address (Head Office)",
        auditor: "📋 Auditor | ผู้สอบบัญชี",
        accountant: "📊 Accountant | ผู้ทำบัญชี",
        others: "📝 Others | อื่น ๆ",
      };
      return map[key] || key;
    },

    goToEdit() {
      this.$router.push(`/incorporate-docket-edit/${this.docket.id}`);
    },

    formatDate(dateStr) {
      if (!dateStr) return "-";
      try {
        const d = new Date(dateStr);
        return d.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      } catch {
        return dateStr;
      }
    },

    getDocketStatusColor(status) {
      const map = {
        "In Progress": "blue lighten-4",
        Complete: "green lighten-4",
        "Request Payment": "pink lighten-4",
        Cancelled: "red lighten-4",
      };
      return map[status] || "grey lighten-3";
    },
    getDocketStatusTextColor(status) {
      const map = {
        "In Progress": "blue darken-2",
        Complete: "green darken-2",
        "Request Payment": "pink darken-2",
        Cancelled: "red darken-2",
      };
      return map[status] || "grey darken-1";
    },
  },
};
